import { useCallback, useEffect, useState } from "react";
import styles from "./AccountReservations.module.css";
import Button from "./Button";
import { Link } from "react-router-dom";
import { getFile, getUserCommands } from "services/api";
import Spinner from "./Spinner";

const AccountReservations = () => {

  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleGetReservations = useCallback(async () => {
    setLoading(true);
    const response = await getUserCommands();
    if (response.success) {
      console.log("Réservations récupérées avec succès", response.data);

      setReservations(response.data);
    } else {
      setError("Erreur lors de la récupération des réservations");
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!reservations.length && !error) {
      handleGetReservations();
    }
  }, [])

  return (
    <div className={styles.AccountReservations}>
      <div className={styles.Title}>Liste de vos réservations</div>
      {loading && (
        <Spinner />
      )}
      <ul className={styles.ReservationsList}>
        {reservations.map((reservation) => {
          // Format date as "15 Janvier 2025 à 10h00"
          const date = new Date(reservation.createdAt);
          const months = [
            "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
            "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
          ];
          const day = date.getDate();
          const month = months[date.getMonth()];
          const year = date.getFullYear();
          const hours = date.getHours().toString().padStart(2, "0");
          const minutes = date.getMinutes().toString().padStart(2, "0");
          const formattedDate = `${day} ${month} ${year} à ${hours}h${minutes}`;

          return (
            <li key={reservation.id}>
              <div className={`${styles.ReservationItem} ${reservation.commandeStatut.name === "Annulée" ? styles.Cancelled : ""}`}>
                <div className={styles.ReservationDetails}>
                  <div className={styles.ReservationNumber}>Commande n°{reservation.commandNumber}</div >
                  <p>Commande réalisée le : {formattedDate}</p>
                </div>
                <div className={styles.ReservationActions}>
                  <div className={styles.Places}>
                    {reservation.places} place(s)
                  </div>
                  <div className={styles.Status}>
                    <span>{reservation.commandeStatut.name}</span>
                  </div>
                  {reservation.invoiceURL && reservation.invoiceURL !== "#" && <div className={styles.Invoice}>
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        getFile(reservation.invoiceURL).then((response) => {
                          if (response && response instanceof Blob) {
                            const url = window.URL.createObjectURL(response);
                            window.open(url, "_blank");
                            setTimeout(() => window.URL.revokeObjectURL(url), 10000);
                          }
                        })
                      }} to={reservation.invoiceURL} className={styles.InvoiceLink}>
                      Télécharger la facture
                    </Link>
                  </div>}
                </div>
              </div>
            </li>
          );
        })}
        {reservations.length === 0 && !loading && (
          <li className={styles.Title}>Aucune réservation trouvée.</li>
        )}
      </ul>
    </div>
  );
}

export default AccountReservations;
